import React, { FC } from "react";
import styles from './checkbox.module.scss';

interface classesCheckbox {
    checkbox?: string;
    input?: string;
    checkmark?: string;
    label?: string;
}

interface CheckboxProps {
    label?: string;
    checked: boolean;
    onChange: (checked:boolean) => void;
    disabled?: boolean;
    className?: string;
    id?: string;
    name?: string;
    backgroundColor?: string
    classes?: classesCheckbox;
    size?: 'large' | 'medium';
}

const Checkbox: FC<CheckboxProps> = ({ label, checked, onChange, disabled, className = '', id, name, classes = {}, size = 'large', backgroundColor }) => {
    return (
        <label className={`${styles.container} ${classes.checkbox || ''} ${className}`}>
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={(e) => onChange(e.currentTarget.checked)}
                disabled={disabled}
                className={`${styles.input} ${classes.input || ''}`}
            />
            <span className={`${styles.checkmark} ${styles[size]} ${classes.checkmark || ''}`} style={{backgroundColor: backgroundColor}}></span>
            <span className={`${styles.text} ${classes.label || ''}`}>
        {label}
      </span>
        </label>
    );
};

export default Checkbox;
